import { DietIdEnum, DietModeType } from '@front-activerse/common-components';

export const DIET_TYPES_PL = [
  {
    id: 1,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.goalSettings.dietType.optionClassic.title',
    optionDescription: 'app.goalSettings.dietType.optionClassic.description',
    renderCondition: (values: any) =>
      values.dietType !== DietIdEnum.DIET_ID_CLASSIC_LVL2 ||
      values.dietType !== DietIdEnum.DIET_ID_CLASSIC_LVL3,
  },
  {
    id: 2,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.goalSettings.dietType.optionClassic.title',
    optionDescription: 'app.goalSettings.dietType.optionClassic.description',
    renderCondition: (values: any) => values.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL2,
  },
  {
    id: 3,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.goalSettings.dietType.optionClassic.title',
    optionDescription: 'app.goalSettings.dietType.optionClassic.description',
    renderCondition: (values: any) => values.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL3,
  },
  {
    id: 10,
    value: DietIdEnum.DIET_ID_VEGE,
    optionTitle: 'app.goalSettings.dietType.optionVege.title',
    optionDescription: 'app.goalSettings.dietType.optionVege.description',
  },
  {
    id: 11,
    value: DietIdEnum.DIET_ID_LOW_IG,
    optionTitle: 'app.goalSettings.dietType.optionLowIG.title',
    optionDescription: 'app.goalSettings.dietType.optionLowIG.description',
  },
  {
    id: 12,
    value: DietIdEnum.DIET_ID_SMART,
    optionTitle: 'app.goalSettings.dietType.optionSmart.title',
    optionDescription: 'app.goalSettings.dietType.optionSmart.description',
  },
];

export const DIET_TYPES_EN = [
  {
    id: 13,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.goalSettings.dietType.optionClassic.title',
    optionDescription: 'app.goalSettings.dietType.optionClassic.description',
  },
  {
    id: 14,
    value: DietIdEnum.DIET_ID_VEGE,
    optionTitle: 'app.goalSettings.dietType.optionVege.title',
    optionDescription: 'app.goalSettings.dietType.optionVege.description',
  },
];

export const DIET_LEVELS = [
  {
    id: 1,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.goalSettings.dietLevel.level1.title',
    optionDescription: 'app.goalSettings.dietLevel.level1.description',
  },
  {
    id: 2,
    value: DietIdEnum.DIET_ID_CLASSIC_LVL2,
    optionTitle: 'app.goalSettings.dietLevel.level2.title',
    optionDescription: 'app.goalSettings.dietLevel.level2.description',
  },
  {
    id: 3,
    value: DietIdEnum.DIET_ID_CLASSIC_LVL3,
    optionTitle: 'app.goalSettings.dietLevel.level3.title',
    optionDescription: 'app.goalSettings.dietLevel.level3.description',
  },
];

export const DIET_MODES = [
  {
    value: DietModeType.slimming,
    optionTitle: 'app.goalSettings.goal.optionWeightLoss.title',
    optionDescription: 'app.goalSettings.goal.optionWeightLoss.description',
  },
  {
    value: DietModeType.stabilization,
    optionTitle: 'app.goalSettings.goal.optionWeightMaintain.title',
    optionDescription: 'app.goalSettings.goal.optionWeightMaintain.description',
  },
  {
    value: DietModeType.gain_muscle_mass,
    optionTitle: 'app.goalSettings.goal.optionBuildMuscle.title',
    optionDescription: 'app.goalSettings.goal.optionBuildMuscle.description',
  },
];

// for i18n-unused
// t('app.goalSettings.dietType.optionClassic.title')
// t('app.goalSettings.dietType.optionClassic.description')
// t('app.goalSettings.dietType.optionVeggie.title')
// t('app.goalSettings.dietType.optionVeggie.description')
// t('app.goalSettings.dietType.optionVegan.title')
// t('app.goalSettings.dietType.optionVegan.description')
// t('app.goalSettings.dietType.optionHighProtein.title')
// t('app.goalSettings.dietType.optionHighProtein.description')
// t('app.goalSettings.dietType.optionGLP1.title')
// t('app.goalSettings.dietType.optionGLP1.description')

// t('app.goalSettings.goal.optionWeightLoss.title')
// t('app.goalSettings.goal.optionWeightLoss.description')
// t('app.goalSettings.goal.optionWeightMaintain.title')
// t('app.goalSettings.goal.optionWeightMaintain.description')
// t('app.goalSettings.goal.optionBuildMuscle.title')
// t('app.goalSettings.goal.optionBuildMuscle.description')
